import { helper as buildHelper } from '@ember/component/helper';
import { htmlEntitiesDecode } from 'sh-www/utils/misc';

export default buildHelper(([encodedString]) => htmlEntitiesDecode(encodedString));
